import * as React from 'react';
import { IMaterialDisplayValue } from '@pages/trucks/materials/MaterialUtils';
import { cs } from '@shared/utils/utils-classname';

export const Volume = ({ stat }) => (
    <span>
        {stat.volume}{' '}
        {stat.volumeUnit > 0 ? (
            stat.volumeUnit == 1 ? (
                <span>
                    m<sup>3</sup>
                </span>
            ) : (
                kuura.getMessage('trucks.tons')
            )
        ) : null}
    </span>
);

export const VolumeCell: React.FC<{
    displayValue: IMaterialDisplayValue;
    tooltip?: string;
}> = ({ displayValue, tooltip }) => {
    if (displayValue.value == null) {
        return null;
    }

    const formatted = parseFloat(displayValue.value.toFixed(2));
    const error = displayValue.value === 0;

    if (!displayValue.isDerived) {
        return (
            <strong className={cs({ errorInData: error })} title={tooltip}>
                {formatted}
            </strong>
        );
    }

    return (
        <span className={cs({ errorInData: error })} title={tooltip} style={{ fontStyle: 'italic', opacity: 0.6 }}>
            {formatted}
        </span>
    );
};

export const Distance = ({ distance }) => <span>{parseFloat((distance / 1000).toFixed(2))} km</span>;
